import { createContext, useContext, useState, useCallback } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import ConsultForm from "@/components/ConsultForm";

const ConsultContext = createContext({ openConsult: () => {} });

export const useConsult = () => useContext(ConsultContext);

export const ConsultProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [country, setCountry] = useState("");

  const openConsult = useCallback((preselectCountry = "") => {
    setCountry(preselectCountry);
    setOpen(true);
  }, []);

  return (
    <ConsultContext.Provider value={{ openConsult }}>
      {children}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          className="max-h-[92vh] overflow-y-auto border-line bg-white p-0 sm:max-w-xl"
          data-testid="consult-modal"
          aria-label="Free consultation form"
        >
          <DialogHeader className="bg-navy px-8 pb-6 pt-8 text-left">
            <DialogTitle className="font-heading text-2xl font-bold text-white">
              Book Your <span className="text-gold">Free</span> Consultation
            </DialogTitle>
            <DialogDescription className="text-sm text-slate-300">
              {country ? `Study in ${country} — ` : ""}Fill this in and our counselors will reach out within 24 hours.
            </DialogDescription>
          </DialogHeader>
          <div className="px-8 py-8">
            <ConsultForm defaultCountry={country} onDone={() => setTimeout(() => setOpen(false), 3200)} />
          </div>
        </DialogContent>
      </Dialog>
    </ConsultContext.Provider>
  );
};
